import { render, staticRenderFns } from "./SdkReferences.vue?vue&type=template&id=80c147f0&"
import script from "./SdkReferences.vue?vue&type=script&lang=js&"
export * from "./SdkReferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80c147f0')) {
      api.createRecord('80c147f0', component.options)
    } else {
      api.reload('80c147f0', component.options)
    }
    module.hot.accept("./SdkReferences.vue?vue&type=template&id=80c147f0&", function () {
      api.rerender('80c147f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/SDK/SdkReferences.vue"
export default component.exports